import { useState } from "react";
import { Head, useForm } from "@inertiajs/react";
import SchoolLayout from "@/components/schools/SchoolLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import FormField from "@/components/forms/FormField";
import DivisionField from "@/components/schools/classroom/DivisionField";
import { defaultDivision } from "@/lib/classroom";

export default function New({ school, membership, campaign_name, division_options, create_path, back }) {
  const { data, setData, post, processing, errors } = useForm({ name: "", grade: "", division: "" });
  // The division follows the grade until the admin picks one themselves.
  const [divisionTouched, setDivisionTouched] = useState(false);

  const changeGrade = (grade) =>
    setData((prev) => ({ ...prev, grade, division: divisionTouched ? prev.division : defaultDivision(grade) }));

  const submit = (e) => {
    e.preventDefault();
    post(create_path);
  };

  return (
    <SchoolLayout school={school} membership={membership} back={back} eyebrow={campaign_name} title="New classroom">
      <Head title="New classroom" />
      <div>
        <Card>
          <CardContent className="pt-6 md:pt-8">
            <form onSubmit={submit} className="space-y-5">
              <div className="grid gap-4 sm:grid-cols-2">
                <FormField name="name" label="Classroom name" required autoFocus placeholder="Room 12" value={data.name} onChange={(e) => setData("name", e.target.value)} error={errors.name} help="The name families know. You'll add students next." />
                <FormField name="grade" label="Grade" required placeholder="Grade 5" value={data.grade} onChange={(e) => changeGrade(e.target.value)} error={errors.grade} />
                <DivisionField
                  value={data.division}
                  onChange={(division) => { setDivisionTouched(true); setData("division", division); }}
                  error={errors.division}
                  options={division_options}
                />
              </div>
              <div className="border-t border-border pt-5">
                <Button type="submit" disabled={processing}>{processing ? "Creating…" : "Create classroom"}</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </SchoolLayout>
  );
}
